/**
 * Phase 2 — Refinance vertical CategoryConfig.
 *
 * Single source of truth for everything refinance-specific. See
 * `/features/insurance/config.js` for full Phase 2 rationale.
 */
import { CTA_REFINANCE } from "../../lib/ctaVocabulary";

export const REFINANCE_CONFIG = {
  id: "refinance",
  label: "Auto Refinance",
  singularProviderLabel: "refinance lender",
  pluralProviderLabel: "refinance lenders",
  providerType: "lender",

  rateTable: {
    sortOptions: ["featured", "lowest-apr", "highest-rated", "lowest-credit"],
    columns: ["lender", "apr", "credit", "loan", "term", "rating", "cta"],
    ctaLabel: CTA_REFINANCE,
    trustLine: "Free · Soft pull · No obligation",
    headerLabel: "Today's refinance offers",
  },

  modalCategory: "refinance",
  weeklyShoppersBenchmark: 950,

  scoreFields: [
    { key: "score_rates", label: "Refi savings", weight: "40%" },
    { key: "score_terms", label: "Loan terms", weight: "25%" },
    { key: "score_application", label: "Application", weight: "20%" },
    { key: "score_support", label: "Customer support", weight: "15%" },
  ],

  adminDetailsFields: [
    { key: "apr_reduction_avg", label: "Avg APR reduction (%)", type: "number" },
    { key: "monthly_savings_avg", label: "Avg monthly savings ($)", type: "number" },
    { key: "payoff_timeline_months", label: "Typical new term (months)", type: "number" },
  ],

  adminTableHeader: {
    pluralNoun: "refi lenders",
    numericA: "APR",
    numericB: "Min FICO",
  },

  primaryCta: CTA_REFINANCE,

  routes: [
    "/refinance",
    "/refinance/:state",
    "/refinance/:state/:city",
    "/refinance-savings-calculator",
    "/refinance-savings-calculator/:state",
  ],

  schemaTypes: ["Product", "Review", "FAQPage", "BreadcrumbList", "Article", "AggregateRating"],

  trustBadges: ["nmls", "softPull"],

  isCreditVertical: true,
};
